var _effectorFileName = "/src/shared/components/ui/input.tsx";
import * as React from 'react';
import { cn } from '@/shared/lib/cn';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  startAdornment?: React.JSX.Element;
  endAdornment?: React.JSX.Element;
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  startAdornment,
  endAdornment,
  ...props
}, ref) => {
  const hasAdornment = Boolean(startAdornment) || Boolean(endAdornment);
  return <>
        {hasAdornment ? <div className="flex h-9 items-center justify-center gap-2 rounded-md border border-brand-accent-light bg-transparent px-3 ring-offset-background focus-within:ring-1 focus-within:ring-brand-accent-dark data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50 dark:border-brand-accent-light" data-disabled={props.disabled}>
            {startAdornment && <div className={cn('text-muted-foreground')}>{startAdornment}</div>}
            <input type={type} className={cn('flex h-full w-full rounded-md border-none bg-transparent py-2 text-sm shadow-none outline-none file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:shadow-none focus-visible:outline-none', className)} ref={ref} {...props} />
            {endAdornment && <div className={cn('text-muted-foreground')}>{endAdornment}</div>}
          </div> : <input type={type} className={cn('flex h-9 w-full rounded-md border border-brand-accent-light bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand-accent-dark disabled:cursor-not-allowed disabled:opacity-50 dark:border-brand-accent-light dark:focus-visible:ring-brand-accent-normal', className)} ref={ref} {...props} />}
      </>;
});
Input.displayName = 'Input';
export { Input };